export default "__VITE_ASSET__CoZ2cucu__"